import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Grid,
  IconButton,
  Stack,
  Box,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { apiStore } from "../../api/ApiFactory";
import { useSelector } from "react-redux";
import { getSeriesList } from "../../store/slices/BoatOrdering/BoatOrderingSelector";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import HelpIcon from "@mui/icons-material/Help";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Checked from "../../_assets/images/checked-icon.png";
import Unchecked from "../../_assets/images/unchecked-icon.png";
import MotorIndex from "./loose-motor/MotorIndex";
import { useAppSelector } from "../../store/hooks/hook";
import { NavMode } from "../../helpers/enums/Layout";

const BoatOrderingSeries = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const seriesList = useSelector(getSeriesList);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { navMode } = useAppSelector((state) => ({
    navMode: state.reducer.Layout.navMode,
  }));
  useEffect(() => {
    apiStore.boatOrderingApi
      .getSeriesList()
      .then((response) => {
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Boat series", error);
      });
  }, []);

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: "#193a4a",
      fontSize: 14,
      fontWeight: "bold",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      borderRadius: 0,
    },
  }));

  const goToModel = (seriesId: any) => {
    if (location.pathname === "/order") {
      navigate(`/order/model/${seriesId}`);
    } else {
      navigate(`/boat/model/${seriesId}`);
    }
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {seriesList?.map((series: any, index: number) => {
        if (!series?.modelCount) {
          return <></>
        }

          return (
            <Grid
              item
              lg={3}
              md={6}
              sm={6}
              xs={12}
              key={index}
              className="container-grid"
            >
              <Card className="configureCard">
                <CardMedia
                  component="img"
                  height="250"
                  image={series?.mediaUrl}
                  alt={series.name}
                />
                <CardContent className="configureCardContent">
                  <Grid
                    container
                    className="series-tooltip"
                    justifyContent="flex-end"
                  >
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <Typography color="inherit">
                            {series?.description}
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <IconButton
                        className="tooltip-btn"
                        aria-label="upload picture"
                        component="label"
                      >
                        <HelpIcon />
                      </IconButton>
                    </HtmlTooltip>
                  </Grid>
                  <Typography
                    gutterBottom={false}
                    variant="h5"
                    component="div"
                    align="center"
                    className="configureCardHeading"
                  >
                    {`${series.name} Series`}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    align="center"
                    gutterBottom
                    className="configureCardModel"
                  >
                    {`${series?.modelCount ? series?.modelCount : 0} Model(s)`}
                  </Typography>
                  <Grid>
                    <Box className="desc-container ">
                      <Typography className="desc-head" mb={1}>
                        {series?.name} Series
                      </Typography>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography className="desc-item">2 Tube</Typography>
                        <Box>
                          {" "}
                          <img
                            src={series?.hasTwoTubeModels ? Checked : Unchecked}
                            alt=""
                          />
                        </Box>
                      </Stack>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography className="desc-item">3 Tube</Typography>
                        <Box>
                          {" "}
                          <img
                            src={
                              series?.hasThreeTubeModels ? Checked : Unchecked
                            }
                            alt=""
                          />
                        </Box>
                      </Stack>
                    </Box>
                    <Box className="desc-container ">
                      <Typography className="desc-head" mb={1}>
                        Floor Plans
                      </Typography>
                      {series?.floorPlans.map(
                        (floorPlan: string, index: number) => (
                          <Stack key={index}>
                            {" "}
                            <Typography className="desc-item">
                              {floorPlan}
                            </Typography>
                          </Stack>
                        )
                      )}
                    </Box>
                  </Grid>
                  <CardActions className="justify-center">
                    <Button
                      size="small"
                      variant="contained"
                      disabled={!series?.modelCount}
                      className="text-capitalize configureCardButton boat-ordering"
                      //onClick={() => navigate(`/boat/model/${series.id}`)}
                      onClick={() => goToModel(series.id)}
                    >
                      View All Models
                    </Button>
                  </CardActions>
                </CardContent>
              </Card>
            </Grid>
          );
        })}

      {navMode !== NavMode.LEADS && (
          <Grid item lg={3} sm={6} md={6} xs={12} className="container-grid">
            <MotorIndex />
          </Grid>
      )}
        
      </Grid>
    </>
  );
};

export default BoatOrderingSeries;
